import { CmsPicture } from '@domgen/dgx-fe-cms';
import { Category } from './cms-category.interface';
import { PopularArticles } from './cms-popular-articles.interface';
import { PopularVideos } from './cms-popular-videos.interface';

export interface YourAppliance {
  applianceCode: string;
  applianceDescription: string;
  popularVideosBlock: PopularVideos | undefined;
  popularArticlesBlock: PopularArticles | undefined;
  articleCategories: Category[];
  picture: CmsPicture;
}
